import { userRepository } from '../repositories/user-repository';

async function getUser() {
    return userRepository.get();
}

export {
    getUser
};
